// extracted by mini-css-extract-plugin
module.exports = {"iconAndTextGrouping":"SourceChip_iconAndTextGrouping__s1TmN","textGrouping":"SourceChip_textGrouping__1bISA","titleText":"SourceChip_titleText__tMbSm"};